import React from 'react'
import { ExternalLink } from 'components'
import { SEATOW_MEMBERSHIP_AGREEMENT_URL } from 'config'

const propTypes = {}

function TermsAgreementContent() {
  return (
    <label>
      I have read and agree to the terms and conditions of the{' '}
      <ExternalLink
        className="external-link-in-text"
        href={SEATOW_MEMBERSHIP_AGREEMENT_URL}
        showIcon={false}
      >
        Sea Tow Membership Agreement
      </ExternalLink>{' '}
      including:
      <ul>
        <li>
          My boat is in good working order at the time of joining/renewing and
          will be reasonably maintained.
        </li>
        <li>
          I understand that membership is effective in 24 hours and is
          non-refundable.
        </li>
      </ul>
    </label>
  )
}

TermsAgreementContent.propTypes = propTypes

export default TermsAgreementContent
